import { connect } from 'react-redux'
import Currency from '../../Utils/Currency'
import { jackpotMessageClosed, message } from '../../redux/actions'
import Component from '../component'

/**
 * A notification that someone has won the jackpot in the current game.
 */
@connect(state => ({ base: state.base }), { message, jackpotMessageClosed })
export default class JackpotWon extends Component {
  /**
   * This function will close the message and let the client
   * know that a jackpot message was closed.
   * @param e
   */
  closeMessage = (e) => {
    const { data } = this.props
    const { jackpot } = data

    e.preventDefault()
    e.stopPropagation()

    this.props.jackpotMessageClosed(jackpot)
    this.props.message(null)
  }

  /**
   * Renders out a message popup as DOM element, displaying
   * jackpot information.
   * @returns {*}
   */
  render() {
    const { data } = this.props
    const { lastWin } = data

    return (
      <div className="popup-content">
        <div className="popup-message">
          {this.t('jackpot.won', { count: Currency.format(lastWin.amount) })}
        </div>

        <br />

        <div className="buttonContainer">
          <button onClick={e => { this.closeMessage(e) }}>{this.t('realityCheck.ok')}</button>
        </div>
      </div>
    )
  }
}
